export const HIERARCHY_CAMPAIGN_REPORT_ID = 'hierarchy-campaign';
